module.exports = __webpack_public_path__ + "img/cargando.06019d75.svg";